var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2524_19370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 3.33333C13.55 3.33333 8.33337 8.55 8.33337 15C8.33337 21.95 15.7 31.5333 18.7334 35.1833C19.4 35.9833 20.6167 35.9833 21.2834 35.1833C24.3 31.5333 31.6667 21.95 31.6667 15C31.6667 8.55 26.45 3.33333 20 3.33333ZM20 19.1667C17.7 19.1667 15.8334 17.3 15.8334 15C15.8334 12.7 17.7 10.8333 20 10.8333C22.3 10.8333 24.1667 12.7 24.1667 15C24.1667 17.3 22.3 19.1667 20 19.1667Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2524_19370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailStation);
export default __webpack_public_path__ + "static/media/detail-station.a2539297e74ac71d48dda2c1d21e4041.svg";
export { ForwardRef as ReactComponent };